// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/backend/app.scss
// module id = 391
// module chunks = 22